import { createSlice } from "@reduxjs/toolkit";
import { assign } from "lodash";
const BenchmarkCreationInitialState = {
    compositionRules: {},
    information: { currency: "", description: "", name: "" },
    selectedTab: 0,
    source: undefined,
    step: 1
};
const slice = createSlice({
    initialState: BenchmarkCreationInitialState,
    name: "benchmarkCreationReducers",
    reducers: {
        changeBenchmarkCreationStep: (state, action) => {
            if (action.payload) {
                state.step = action.payload;
            }
        },
        resetBenchmarkCreation: () => BenchmarkCreationInitialState,
        setBenchmarkGeneralInformation: (state, action) => {
            if (action.payload) {
                assign(state.information, action.payload);
            }
        },
        setBenchmarkSource: (state, action) => {
            state.source = action.payload;
        },
        setCompositionRules: (state, action) => {
            state.compositionRules = action.payload;
        },
        setSelectedTabUid: (state, action) => {
            state.selectedTab = action.payload;
        }
    }
});
export const benchmarkCreationReducers = slice.reducer;
export const { changeBenchmarkCreationStep, setCompositionRules, setBenchmarkGeneralInformation, setBenchmarkSource, resetBenchmarkCreation, setSelectedTabUid } = slice.actions;
